import { Box, Chip } from "@mui/material";
import { UnifiedDashboard } from "../../containers/pages/CANsense/UnifiedDashboard";
import FeatureErrorBoundary from "../../components/errorBoundary/FeatureErrorBoundary";
import logo from '../../assets/images/stream.png';

function DashboardPage() {
  return (
    <FeatureErrorBoundary featureName="CANsense">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "95vh",
        }}
      >
        <Box sx={{ flex: 1, backgroundColor: "transparent" }}>
          <UnifiedDashboard />
        </Box>

        <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
          <Chip
            label="Powered by Stream Data Systems"
            variant="outlined"
            icon={
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{ width: 20, height: 20 }}
              />
            }
          />
        </Box>
      </Box>
    </FeatureErrorBoundary>
  );
}

export default DashboardPage;
